import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import {
  LAYOFF_PERMISSION,
  LAYOFF_REVIEW_PERMISSION,
  useLayoffAccess,
} from './useLayoff';
import LayoffTracker from './LayoffTracker';
import SendLayoff from './SendLayoff';
import ReviewLayoff from './Review/ReviewLayoff';
import styles from './layoff.module.scss';

const LayoffContainer = ({ match }) => {
  // Undefined until the Navbar has loaded the current user's permissions
  const permissions = useSelector(
    (state) => state?.permission?.permissions?.data,
  );
  // Payroll has no lay-off permission, and only Super Admins can send: the API says which
  const access = useLayoffAccess(!!permissions);

  if (!permissions || access.isLoading) {
    return (
      <div className={styles.page_message}>
        <img
          alt='Loading'
          src={require('../assets/images/loader.gif').default}
        />
      </div>
    );
  }

  const canManage = permissions.includes(LAYOFF_PERMISSION);
  const canReview =
    canManage ||
    permissions.includes(LAYOFF_REVIEW_PERMISSION) ||
    !!access.data?.review;
  const canSend = access.data ? !!access.data.send : canManage;

  // Without tracker access, the review page still opens from an email link;
  // the API decides what the user can see and do there
  if (!canReview) {
    return (
      <Switch>
        <Route
          exact
          path={`${match.path}/review/:hash`}
          component={ReviewLayoff}
        />
        <Route>
          <div className={styles.page_message}>
            You don't have access to lay-off documents.
          </div>
        </Route>
      </Switch>
    );
  }

  return (
    <Switch>
      {canSend && (
        <Route exact path={`${match.path}/send`} component={SendLayoff} />
      )}
      <Route
        exact
        path={`${match.path}/review/:hash`}
        component={ReviewLayoff}
      />
      <Route
        exact
        path={match.path}
        render={(props) => (
          <LayoffTracker {...props} canManage={canManage} canSend={canSend} />
        )}
      />
    </Switch>
  );
};

export default LayoffContainer;
